module.exports = __webpack_public_path__ + "static/media/sustainable-solutions.93de0fa8.jpg";